'use strict';

define('vb/action/builtin/ifAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Represents an action that evaluates a condition and returns a boolean outcome.
   *
   * @extends Action
   * @category Action
   */
  class IfAction extends Action {
    /**
     * Performs the conditional evaluation of the IfAction.
     *
     * @param {Object} parameters - The input parameters for the action.
     * @param {boolean} parameters.condition - The condition to evaluate.
     *
     * @returns {Outcome} The outcome of the conditional evaluation, either TRUE or FALSE.
     */
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      const condition = parameters.condition;

      return condition ? Action.createOutcome(Action.Outcomes.TRUE, true)
        : Action.createOutcome(Action.Outcomes.FALSE, false);
    }
  }

  return IfAction;
});

